<template>
    <div class="has-text-centered">
        <div class="is-inline-block loader"></div>
    </div>
</template>

<script>
export default {
}
</script>
